import React from 'react';
import * as classnames from 'classnames/bind';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {BoxTitle} from './BoxTitle';

const styles = require('./OtherUserSelection.less');
const cx = classnames.bind(styles);

interface OtherUserSelectionProps {
    userId:number;
}

export class OtherUserSelection extends React.Component<OtherUserSelectionProps>
{
    public render()
    {
        const {activeUsers} = rootState.ui.visualDesigner;
        const userDetails = activeUsers.otherUsersDetails.get(this.props.userId);

        if( !userDetails )
            return null;

        return <div className={cx('otherUserSelection')} style={{borderColor:userDetails.color}}>
            <BoxTitle
                displayName={userDetails.fullName}
                className={cx('boxTitleRight')}
                style={{backgroundColor:userDetails.color}}
            />
        </div>
    }
    
}